module.exports = __webpack_public_path__ + "static/health1-e655ccdb13740b2b4de45c6a1fecfd73.jpeg";